export const G_TRACKING_ID = 'G-PYKSNR269V';
